module.exports = __webpack_public_path__ + "img/oculus_hifi_1.ef278fde.png";